import React from 'react';

import styled from 'styled-components';

const Loading = () => {
  return (
    <StyledSearchIconWrapper
      width="100"
      height="100"
      viewBox="0 0 100 100"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* <!-- Background --> */}
      <circle cx="50" cy="50" r="41" fill="#F2F4FF" />
      <circle
        id="outerLine"
        cx="50"
        cy="50"
        r="46.8109"
        transform="rotate(3.35681 50 50)"
        stroke="#B5B9FB"
        strokeDasharray="5 3"
      />
      <circle
        id="innerLine"
        cx="50.5"
        cy="49.5"
        r="37"
        stroke="#ACB1FA"
        strokeDasharray="5 3"
      />

      {/* <!-- Paper --> */}
      <rect
        x="6.80139"
        y="23.8358"
        width="48.3461"
        height="69.4944"
        rx="1.5"
        fill="white"
        stroke="#DADADA"
      />
      <line
        x1="13.8014"
        y1="33.8358"
        x2="48.8014"
        y2="33.8358"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="13.8014"
        y1="45.8358"
        x2="48.8014"
        y2="45.8358"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="13.8014"
        y1="57.8358"
        x2="48.8014"
        y2="57.8358"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="13.8014"
        y1="69.8358"
        x2="48.8014"
        y2="69.8358"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="13.8014"
        y1="81.8358"
        x2="48.8014"
        y2="81.8358"
        stroke="#DADADA"
        strokeLinecap="round"
      />

      {/* <!-- Particle --> */}
      <circle id="particle1" cx="31.9635" cy="93.3301" r="3.5" fill="#4D6AF2" />

      {/* <!-- Spreadsheet --> */}
      <rect
        x="34.5233"
        y="71.568"
        width="43.2489"
        height="27.932"
        rx="1.5"
        fill="white"
        stroke="#DADADA"
      />
      <line
        x1="35.0524"
        y1="78.7541"
        x2="77.7642"
        y2="78.7541"
        stroke="#DADADA"
      />
      <line
        x1="42.948"
        y1="81.4997"
        x2="42.948"
        y2="96.7739"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="51.4574"
        y1="81.4997"
        x2="51.4574"
        y2="96.7739"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="59.9668"
        y1="81.4997"
        x2="59.9668"
        y2="96.7739"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="68.4761"
        y1="81.4997"
        x2="68.4761"
        y2="96.7739"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <line
        x1="39.1287"
        y1="85.4997"
        x2="72.1663"
        y2="85.4997"
        stroke="#DADADA"
        strokeLinecap="round"
      />
      <path
        d="M39.1287 91.9997H72.1663"
        stroke="#DADADA"
        strokeLinecap="round"
      />

      {/* <!-- Particle --> */}
      <circle id="particle2" cx="71.4763" cy="71.0681" r="3.5" fill="#ACB1FA" />

      {/* <!-- Particle --> */}
      <circle id="particle3" cx="55.6473" cy="23.3357" r="3.5" fill="#FFBB00" />

      {/* <!-- Looking glass --> */}
      <g id="lookingGlass">
        <g id="lookingGlassInner">
          <mask id="path-20-inside-1" fill="white">
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M48.9779 62.3786C53.3157 67.1497 60.3241 68.0464 65.6539 64.8617C65.706 64.9316 65.7619 64.9996 65.8218 65.0655L81.9495 82.8043C82.9392 83.8928 84.6239 83.973 85.7124 82.9833C86.801 81.9936 86.8811 80.3089 85.8914 79.2203L69.7638 61.4815C69.7039 61.4157 69.6414 61.3535 69.5767 61.295C73.2528 56.2916 73.0254 49.23 68.6877 44.459C63.7393 39.0162 55.3157 38.6155 49.873 43.5639C44.4303 48.5123 44.0296 56.9359 48.9779 62.3786ZM65.1046 60.3173C61.2947 63.7811 55.3982 63.5006 51.9343 59.6907C48.4705 55.8808 48.751 49.9843 52.5609 46.5204C56.3708 43.0565 62.2673 43.3371 65.7312 47.1469C69.195 50.9568 68.9145 56.8534 65.1046 60.3173Z"
            />
          </mask>
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M48.9779 62.3786C53.3157 67.1497 60.3241 68.0464 65.6539 64.8617C65.706 64.9316 65.7619 64.9996 65.8218 65.0655L81.9495 82.8043C82.9392 83.8928 84.6239 83.973 85.7124 82.9833C86.801 81.9936 86.8811 80.3089 85.8914 79.2203L69.7638 61.4815C69.7039 61.4157 69.6414 61.3535 69.5767 61.295C73.2528 56.2916 73.0254 49.23 68.6877 44.459C63.7393 39.0162 55.3157 38.6155 49.873 43.5639C44.4303 48.5123 44.0296 56.9359 48.9779 62.3786ZM65.1046 60.3173C61.2947 63.7811 55.3982 63.5006 51.9343 59.6907C48.4705 55.8808 48.751 49.9843 52.5609 46.5204C56.3708 43.0565 62.2673 43.3371 65.7312 47.1469C69.195 50.9568 68.9145 56.8534 65.1046 60.3173Z"
            fill="white"
          />
          <path
            d="M65.6539 64.8617L66.4561 64.2645L65.9166 63.5398L65.141 64.0032L65.6539 64.8617ZM48.9779 62.3786L48.238 63.0513H48.238L48.9779 62.3786ZM65.8218 65.0655L65.0819 65.7382L65.0819 65.7382L65.8218 65.0655ZM81.9495 82.8043L82.6894 82.1316L82.6894 82.1316L81.9495 82.8043ZM85.7124 82.9833L86.3851 83.7232L85.7124 82.9833ZM85.8914 79.2203L85.1515 79.8931L85.8914 79.2203ZM69.7638 61.4815L69.0238 62.1542L69.0238 62.1542L69.7638 61.4815ZM69.5767 61.295L68.7709 60.7029L68.2359 61.431L68.9062 62.0369L69.5767 61.295ZM68.6877 44.459L67.9478 45.1317L68.6877 44.459ZM49.873 43.5639L49.2003 42.824L49.2003 42.824L49.873 43.5639ZM51.9343 59.6907L51.1944 60.3634L51.9343 59.6907ZM65.1046 60.3173L65.7773 61.0572L65.1046 60.3173ZM52.5609 46.5204L51.8882 45.7805L52.5609 46.5204ZM65.7312 47.1469L64.9913 47.8197L65.7312 47.1469ZM65.141 64.0032C60.2117 66.9486 53.7292 66.118 49.7178 61.7059L48.238 63.0513C52.9023 68.1815 60.4365 69.1442 66.1669 65.7201L65.141 64.0032ZM66.5617 64.3928C66.5238 64.3511 66.4887 64.3083 66.4561 64.2645L64.8518 65.4588C64.9233 65.5549 65 65.6481 65.0819 65.7382L66.5617 64.3928ZM82.6894 82.1316L66.5617 64.3928L65.0819 65.7382L81.2096 83.477L82.6894 82.1316ZM85.0397 82.2434C84.3598 82.8615 83.3075 82.8115 82.6894 82.1316L81.2096 83.477C82.5708 84.9742 84.888 85.0844 86.3851 83.7232L85.0397 82.2434ZM85.1515 79.8931C85.7697 80.5729 85.7196 81.6252 85.0397 82.2434L86.3851 83.7232C87.8823 82.362 87.9926 80.0448 86.6314 78.5476L85.1515 79.8931ZM69.0238 62.1542L85.1515 79.8931L86.6314 78.5476L70.5037 60.8088L69.0238 62.1542ZM68.9062 62.0369C68.9467 62.0735 68.986 62.1126 69.0238 62.1542L70.5037 60.8088C70.4218 60.7187 70.3362 60.6335 70.2473 60.5531L68.9062 62.0369ZM67.9478 45.1317C71.9591 49.5436 72.1707 56.0755 68.7709 60.7029L70.3826 61.8871C74.3349 56.5077 74.0918 48.9163 69.4276 43.7862L67.9478 45.1317ZM50.5457 44.3038C55.5798 39.7269 63.371 40.0976 67.9478 45.1317L69.4276 43.7862C64.1077 37.9349 55.0516 37.5041 49.2003 42.824L50.5457 44.3038ZM49.7178 61.7059C45.141 56.6718 45.5116 48.8807 50.5457 44.3038L49.2003 42.824C43.3489 48.1439 42.9181 57.2 48.238 63.0513L49.7178 61.7059ZM51.1944 60.3634C55.0298 64.582 61.5588 64.8926 65.7773 61.0572L64.4319 59.5773C61.0307 62.6697 55.7666 62.4193 52.6742 59.018L51.1944 60.3634ZM51.8882 45.7805C47.6696 49.6159 47.359 56.1449 51.1944 60.3634L52.6742 59.018C49.5819 55.6168 49.8323 50.3527 53.2336 47.2603L51.8882 45.7805ZM66.4711 46.4742C62.6357 42.2557 56.1067 41.9451 51.8882 45.7805L53.2336 47.2603C56.6348 44.168 61.8989 44.4184 64.9913 47.8197L66.4711 46.4742ZM65.7773 61.0572C69.9959 57.2218 70.3065 50.6928 66.4711 46.4742L64.9913 47.8197C68.0836 51.2209 67.8332 56.485 64.4319 59.5773L65.7773 61.0572Z"
            fill="#DADADA"
            mask="url(#path-20-inside-1)"
          />
        </g>
      </g>
    </StyledSearchIconWrapper>
  );
};

const StyledSearchIconWrapper = styled.svg`
  @keyframes cw {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
  @keyframes ccw {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(-360deg);
    }
  }

  #outerLine {
    animation: cw 70s linear infinite;
    transform-origin: center center;
  }

  #innerLine {
    animation: ccw 90s linear infinite;
    transform-origin: center center;
  }

  #lookingGlass {
    animation: cw 10s ease-in-out infinite;
    transform-origin: 45px 55px;
  }

  #lookingGlassInner {
    animation: ccw 10s ease-in-out infinite;
    transform-origin: center center;
  }

  #particle1 {
    animation: ccw 16s ease-in-out infinite;
    transform-origin: 29px 93px;
  }

  #particle2 {
    animation: ccw 12s ease-in-out infinite;
    transform-origin: 70px 70px;
  }

  #particle3 {
    animation: cw 28s ease-in-out infinite;
    transform-origin: 53px 35px;
  }
`;

export default Loading;
